<template>
  <hm-content title>
    <div class="flex mb20">
    </div>
    <el-table
      :data="list"
      style="width: 100%"
      ref="table"
      stripe
      border
      size="small"
    >
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        label="序号"
        width="50"
        :index="index => index + (currentPage - 1) * pageSize + 1"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="提现单号"
        prop="getcashSn"
      ></el-table-column>      
      <el-table-column
        header-align="center"
        align="center"
        label="交易时间"
        prop="createTime"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="对方姓名"
        prop="createBy"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="对方号码"
        prop="authMobile"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="交易金额"
        prop="getcashMoney"
      ></el-table-column>      
      <el-table-column
        header-align="center"
        align="center"
        label="提现状态"
        prop="auditState"
      >
        <template slot-scope="scope">
          <div class="success" v-if="scope.row.auditState==='agree'">提现成功</div>
          <div class="gray" v-if="scope.row.auditState==='wait'">提现中</div>
          <div class="danger" v-else-if="scope.row.auditState==='refuse'">提现失败</div>
        </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="备注"
        prop="remark"
      >
        <template slot-scope="scope">
            <el-image
              style="width:100px; height:100px"
              :src="item"
              :preview-src-list="[scope.row.agreeCertList]"     
              v-for="(item, indexList) in scope.row.agreeCertList"
              :key="indexList"
            >
            </el-image>
            <div>{{scope.row.agreeRemark}}</div>
        </template>  
      </el-table-column>
    </el-table>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @size-change="handleSizeChange"
        @current-change="paging"
        layout="total,sizes,  prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="800px"
    >
    </el-dialog>
  </hm-content>
</template>

<script>
import area from "@/utils/area";
export default {
  components: {},
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      title: "",
      ruleForm:{
        name:"",
        content: "",
        bankCard: "",
      },
      bankCardList: [
        {
          label: "微信",
          value: "weChat",
        },
        {
          label: "支付宝",
          value: "aliPay",
        },
        {
          label: "银行卡",
          value: "aliPayNew",
        }
      ],
      rules: {

      },
      mchId: "",
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.mchId = this.$route.query.mchId;
    this.queryList();    
  },
  methods: {
    async queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        callbackReceiveAccount : this.mchId,
      };
      const { result } = await this.$store.dispatch(
        "getcashQueryFlowerList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.list.forEach(v => {    
        if(v.agreeCert){
          v.agreeCertList = v.agreeCert.split(',');
        }
      });
      console.log("this.list:",this.list)
      this.total = total;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
  }
};
</script>
<style lang="scss" scoped>
.red{
  color: #E50065;
}
</style>
